module.exports = __webpack_public_path__ + "01ea978f/img/link-icon.fa09ed66.svg";